import UiForm from "./UiForm";
import { EnumMiezzFormItemType, MiezzFormItem } from "@/models/MiezzForm";
import { EnumOrderServiceType, EnumOrderServiceTypeOption } from "./EnumOrderServiceType";
import DtoPutOrderPoolExpress_CarryAddress_CompanyAddress from "./DtoPutOrderPoolExpress_CarryAddress_CompanyAddress";
import UiGroup from "./UiGroup";

/**
 * 
 * @description 自动生成的代码,请勿修改
 */
export default class DtoPutOrderPoolExpress_CarryAddress extends UiForm<string> {
    constructor() {
        //无参构造函数
        super()
        this.UiGroups = [];
    }

    [proName: string]: any;
    /**
     * 委托书Id
     */
    PoolId?: string;
    /**
     * 订单Id
     */
    OrderId?: string;
    /**
     * 服务类型
     */
    ServiceType?: EnumOrderServiceType;
    /**
     * 提货地址Id
     */
    CarryAddressId?: string;
    /**
     * 提货地址
     */
    CarryAddress?: DtoPutOrderPoolExpress_CarryAddress_CompanyAddress;
    /**
     * 提货计划时间
     */
    CarryPlanTime?: Date;
}

/**
 * -表单校验
 */
export const DtoPutOrderPoolExpress_CarryAddressRules = {
}

/**
 * -设置项
 */
export const DtoPutOrderPoolExpress_CarryAddressMiezzFormItems: MiezzFormItem[] = [
  {
    Prop: "CarryAddress",
    Label: "提货地址",
    Customize: true,
  },
]
